import { formattingNumber } from './../utils'

export const generate_three_option = () => ({
    title: {
        text: '差异百分比',
        textStyle: {
            color: '#c8c8c8',
            fontSize: 12,
        },
        top: 0,
        left: 'center',
    },
    color:['#EEB499', '#C5CB81'],
    label: {
        distance:10
    },
    tooltip: {
        trigger: 'axis',
        axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
        }
    },
    grid: {
        show: false, // 不显示网格
        borderWidth: 0, 
        top:'15%',
        left: '3%',
        right: '3%',
        bottom: 0,
        // bottom: '3%',
        containLabel: true
    },
    xAxis: {
        type: 'value',
        show:false,
        minorTick: {
            show:false
        },
        minorSplitLine: {
            show:false
        },
        splitLine: {
            show: false
        }
    },
    yAxis: {
        type: 'category',
        axisLine: {
            show: true
        },
        axisLabel: {
            show: false
        },
        axisTick: {
            show: false
        },
        splitLine: {
            show: false
        },
        // data: ['周日', '周六', '周五', '周四', '周三', '周二', '周一']
    },
    series: [
        {
            name: '差异百分比',
            type: 'bar',
            stack: '总量',
            barWidth: 2,
            label: {
                show: true,
                position: 'left'
            },
            markPoint: {
                symbol: 'circle',
                symbolSize: 10,
                label: {
                    show:false
                },
                data: []
            },
            data:[]
        }
    ]
});

export const handle_three_data = (value, max, callback = formattingNumber) => {
    let position = value >= 0 ? 'right' : 'left'
    const color = '#000000' // color = value>0? '#EB8282':'#54C4A0'
    if (value >= 0 && value !== Infinity && Math.abs(value / max) > 0.55) {
        position = 'insideBottomRight'
        // color = '#000000'
    }
    if (value < 0 && value !== -Infinity && Math.abs(value / max) > 0.55) {
        position = 'insideBottomLeft'
        // color = '#000000'
    }
    return {
        value:[Infinity, -Infinity].includes(value) ? 0 : value,
        label: {
            show:true,
            color,
            formatter:() => [Infinity, -Infinity].includes(value) ? '上月数据为0' : `${callback(value, 2)}%`,
            position,
        },
        itemStyle: {
            // opacity:0.6,
            //  color:['#EEB499','#C5CB81'],
            color:  value > 0 ? '#EEB499' : '#C5CB81',
            // borderType: 'solid',
            // borderWidth: 2,
            // borderColor: value>0? '#EB8282':'#54C4A0',
        }
    }
} 